{
  "familyId": "SWW-TT-MEERVOUD",
  "questions": [
    {
      "id": "SWW-TT-MEERVOUD-001",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Lees de twee zinnen. In welke zin is de werkwoordsvorm correct?\nA: 'De kinderen speelt op het plein.'\nB: 'De kinderen spelen op het plein.'",
      "context": null,
      "options": ["Alleen zin B is correct", "Alleen zin A is correct", "Beide zinnen zijn correct", "Geen van beide is correct"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud tegenwoordige tijd",
            "content": "Bij een meervoudig onderwerp (wij/jullie/zij/de kinderen) gebruik je de infinitief (basisvorm op -en). Bij enkelvoud (hij/zij/het) gebruik je stam + t.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_beoordeel_zin",
      "variantIndex": 1,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Bepaal eerst het onderwerp: 'de kinderen' is meervoud (meer dan één kind). Bij meervoud gebruik je de infinitief: spelen. Zin A gebruikt 'speelt' (stam + t) — dat hoort bij enkelvoud (hij speelt). Zin B gebruikt 'spelen' (infinitief) — dat is correct bij meervoud. Controleer: verander het onderwerp naar 'het kind' → 'het kind speelt'. Dus 'speelt' hoort bij enkelvoud, 'spelen' bij meervoud.",
        "solutionSteps": [
          "Bepaal het onderwerp: 'de kinderen' → meervoud",
          "Regel: bij meervoud → infinitief (basisvorm op -en)",
          "Zin A: 'speelt' = stam + t → hoort bij enkelvoud → fout",
          "Zin B: 'spelen' = infinitief → hoort bij meervoud → correct"
        ],
        "distractorExplanations": {
          "0": "Goed! 'De kinderen' is meervoud, dus je gebruikt de infinitief: spelen. Alleen zin B is correct.",
          "1": "Je dacht waarschijnlijk dat 'speelt' bij 'de kinderen' hoort. Maar 'speelt' (stam + t) gebruik je bij enkelvoud: hij speelt, zij speelt. Bij meervoud (de kinderen) gebruik je de infinitief: spelen. Controleer door het onderwerp te veranderen: 'het kind speelt' maar 'de kinderen spelen'.",
          "2": "Je dacht waarschijnlijk dat beide vormen kunnen. Maar 'speelt' hoort alleen bij enkelvoud (hij/zij/het) en 'spelen' bij meervoud (wij/jullie/zij/de kinderen). Je kunt niet allebei gebruiken bij hetzelfde onderwerp. Onthoud: meervoud = altijd infinitief.",
          "3": "Je dacht waarschijnlijk dat geen van beide klopt. Maar zin B is wél correct: 'de kinderen spelen' gebruikt de juiste meervoudsvorm (infinitief). Onthoud: bij meervoud gebruik je de infinitief (de vorm op -en)."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-002",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft: 'Jullie werkt heel hard aan het project.' Wat moet de leerling verbeteren?",
      "context": null,
      "options": ["'werkt' moet 'werken' worden", "'werkt' moet 'werk' worden", "De zin is al correct", "'werkt' moet 'werkten' worden"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud tegenwoordige tijd",
            "content": "Bij wij/jullie/zij gebruik je de infinitief: werken, lopen, spelen. De infinitief eindigt altijd op -en. 'Werkt' (stam + t) hoort bij hij/zij/het.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_fout_herkennen",
      "variantIndex": 2,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bepaal eerst het onderwerp: 'jullie' is meervoud. Bij meervoud gebruik je de infinitief (basisvorm op -en): werken. De leerling schreef 'werkt' — dat is stam + t, en dat hoort bij enkelvoud (hij werkt). Verbeter: 'Jullie werken heel hard aan het project.' Controleer: verander 'jullie' naar 'hij' → 'hij werkt'. Dus 'werkt' hoort bij enkelvoud, niet bij meervoud.",
        "solutionSteps": [
          "Bepaal het onderwerp: 'jullie' → meervoud",
          "Regel: bij meervoud → infinitief (op -en)",
          "'Werkt' = stam + t → hoort bij enkelvoud → fout bij 'jullie'",
          "Verbetering: 'jullie werken'"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Jullie' is meervoud, dus je gebruikt de infinitief: werken. 'Werkt' moet 'werken' worden.",
          "1": "Je dacht waarschijnlijk dat de stam ('werk') bij 'jullie' hoort. Maar de stam gebruik je bij 'ik': ik werk. Bij 'jullie' (meervoud) gebruik je de infinitief: jullie werken. Onthoud: ik = stam, wij/jullie/zij = infinitief.",
          "2": "Je dacht waarschijnlijk dat 'werkt' correct is bij 'jullie'. Maar 'werkt' (stam + t) hoort bij enkelvoud: hij werkt. Bij meervoud (jullie) gebruik je de infinitief: werken. Controleer door het onderwerp te veranderen.",
          "3": "Je dacht waarschijnlijk dat 'werkten' correct is. Maar 'werkten' is de verleden tijd (meervoud). De zin staat in de tegenwoordige tijd. Bij 'jullie' in de tegenwoordige tijd: jullie werken. Onthoud: tegenwoordige tijd ≠ verleden tijd."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-003",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Welke zin bevat een fout in de werkwoordsvorm?\nA: 'Zij zingt een mooi lied.' (zij = het meisje)\nB: 'Zij zingen een mooi lied.' (zij = de leerlingen)",
      "context": null,
      "options": ["Geen van beide bevat een fout", "Zin A bevat een fout", "Zin B bevat een fout", "Beide zinnen bevatten een fout"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "'Zij' enkelvoud of meervoud?",
            "content": "Let op: 'zij' kan enkelvoud zijn (zij = dat meisje → stam + t: zingt) of meervoud (zij = de leerlingen → infinitief: zingen). Beide vormen zijn correct, afhankelijk van de betekenis.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_zij_dubbelzinnig",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.meervoud-als-enkelvoud-vervoegd", "label": "Enkelvoudsvorm 'zingt' aangezien als fout bij meervoud 'zij'", "optionIndex": 1 },
          { "id": "sww.correct-form-marked-wrong", "label": "Correcte meervoudsvorm 'zingen' aangezien als fout", "optionIndex": 2 },
          { "id": "sww.correct-form-marked-wrong", "label": "Beide correcte vormen aangezien als fout", "optionIndex": 3 }
        ]
      },
      "variantIndex": 3,
      "citoDifficulty": 0.37,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Let op: 'zij' kan enkelvoud óf meervoud zijn. In zin A is 'zij' enkelvoud (het meisje) → stam + t: zingt ✓. In zin B is 'zij' meervoud (de leerlingen) → infinitief: zingen ✓. Beide zinnen zijn correct! De context bepaalt of 'zij' enkelvoud of meervoud is. Controleer: bij enkelvoud kun je 'zij' vervangen door 'hij' (hij zingt), bij meervoud door 'wij' (wij zingen).",
        "solutionSteps": [
          "Zin A: 'zij' = het meisje → enkelvoud → stam + t: zingt ✓",
          "Zin B: 'zij' = de leerlingen → meervoud → infinitief: zingen ✓",
          "Beide zinnen zijn correct — de context bepaalt de vorm",
          "Controleer: enkelvoud → hij zingt ✓, meervoud → wij zingen ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Beide zinnen zijn correct. 'Zij' kan enkelvoud (zingt) of meervoud (zingen) zijn, afhankelijk van de context.",
          "1": "Je dacht waarschijnlijk dat 'zingt' fout is bij 'zij'. Maar in zin A is 'zij' enkelvoud (het meisje), dus stam + t is correct: zij zingt. Onthoud: 'zij' kan zowel enkelvoud als meervoud zijn — kijk naar de context.",
          "2": "Je dacht waarschijnlijk dat 'zingen' fout is bij 'zij'. Maar in zin B is 'zij' meervoud (de leerlingen), dus de infinitief is correct: zij zingen. Onthoud: bij meervoud gebruik je altijd de infinitief.",
          "3": "Je dacht waarschijnlijk dat beide fout zijn. Maar beide vormen zijn correct in hun eigen context. 'Zij zingt' (enkelvoud) en 'zij zingen' (meervoud) zijn allebei goed. Onthoud: de context bepaalt of 'zij' enkelvoud of meervoud is."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-004",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Een meester vraagt de klas om de fout te vinden. Welk werkwoord is fout gespeld?\n'Wij fietsen naar school en hij loop naast ons.'",
      "context": null,
      "options": [
        "'loop' moet 'loopt' zijn",
        "'fietsen' moet 'fietst' zijn",
        "'loop' moet 'lopen' zijn",
        "Er zit geen fout in de zin"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Enkelvoud vs. meervoud",
            "content": "Wij/jullie/zij → infinitief (fietsen ✓). Hij/zij/het → stam + t (loopt ✓, niet 'loop'). Ik → stam (ik loop).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_gemengde_zin",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Ontleed de zin in twee delen. Deel 1: 'Wij fietsen' — 'wij' is meervoud, dus infinitief: fietsen ✓. Deel 2: 'hij loop' — 'hij' is enkelvoud, dus stam + t: loopt. 'Loop' is de stam zonder t — dat hoort bij 'ik' (ik loop). Bij 'hij' moet er een t achter: hij loopt. Controleer: verander 'hij' naar 'ik' → 'ik loop'. Verander terug naar 'hij' → 'hij loopt'.",
        "solutionSteps": [
          "Deel 1: 'wij fietsen' → meervoud → infinitief → correct ✓",
          "Deel 2: 'hij loop' → enkelvoud → stam + t nodig",
          "Stam van 'lopen' = 'loop' → hij loopt",
          "Fout: 'loop' moet 'loopt' zijn"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Hij' is enkelvoud, dus je gebruikt stam + t: loopt. 'Loop' (zonder t) hoort bij 'ik'.",
          "1": "Je dacht waarschijnlijk dat 'fietsen' fout is. Maar 'wij' is meervoud, dus de infinitief 'fietsen' is correct. Onthoud: meervoud = infinitief. De fout zit bij 'hij loop' — dat moet 'hij loopt' zijn.",
          "2": "Je dacht waarschijnlijk dat 'loop' de infinitief 'lopen' moet worden. Maar 'hij' is enkelvoud — bij enkelvoud gebruik je stam + t: loopt. De infinitief 'lopen' hoort bij meervoud (wij lopen). Onthoud: hij/zij/het = stam + t.",
          "3": "Je dacht waarschijnlijk dat de zin correct is. Maar 'hij loop' mist de t: bij 'hij' (enkelvoud) gebruik je stam + t: hij loopt. Onthoud: ik = stam (loop), hij = stam + t (loopt)."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-005",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "multiple_choice",
      "question": "Een juf schrijft drie zinnen op het bord. Welke zin is correct?\nA: 'De vogels vliegt over het dak.'\nB: 'De vogels vliegen over het dak.'\nC: 'De vogels vlieg over het dak.'",
      "context": null,
      "options": ["Zin B", "Zin A", "Zin C", "Alle drie zijn correct"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud = infinitief",
            "content": "Bij een meervoudig onderwerp (de vogels) gebruik je de infinitief: vliegen. Niet stam + t (vliegt) en niet de stam alleen (vlieg).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_drie_opties",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.meervoud-als-enkelvoud-vervoegd", "label": "Stam+t vorm 'vliegt' gekozen bij meervoud", "optionIndex": 1 },
          { "id": "sww.stam-alleen-bij-meervoud", "label": "Stam zonder uitgang 'vlieg' gekozen bij meervoud", "optionIndex": 2 },
          { "id": "sww.correct-form-marked-wrong", "label": "Drie verschillende vormen alle als correct beoordeeld", "optionIndex": 3 }
        ]
      },
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Bepaal het onderwerp: 'de vogels' is meervoud (meer dan één vogel). Bij meervoud gebruik je de infinitief: vliegen. Zin A: 'vliegt' = stam + t → hoort bij enkelvoud (de vogel vliegt) → fout. Zin B: 'vliegen' = infinitief → hoort bij meervoud → correct ✓. Zin C: 'vlieg' = stam → hoort bij 'ik' (ik vlieg) → fout. Controleer: verander naar enkelvoud: 'de vogel vliegt'. Meervoud: 'de vogels vliegen'.",
        "solutionSteps": [
          "Bepaal het onderwerp: 'de vogels' → meervoud",
          "Regel: meervoud → infinitief (basisvorm op -en)",
          "Zin A: 'vliegt' = stam + t → enkelvoud → fout bij meervoud",
          "Zin B: 'vliegen' = infinitief → meervoud → correct ✓",
          "Zin C: 'vlieg' = stam → hoort bij 'ik' → fout bij meervoud"
        ],
        "distractorExplanations": {
          "0": "Goed! 'De vogels' is meervoud, dus je gebruikt de infinitief: vliegen. Zin B is correct.",
          "1": "Je dacht waarschijnlijk dat 'vliegt' bij 'de vogels' hoort. Maar 'vliegt' (stam + t) hoort bij enkelvoud: de vogel vliegt. Bij meervoud (de vogels) gebruik je de infinitief: vliegen. Controleer: verander naar 'de vogel' → 'de vogel vliegt'.",
          "2": "Je dacht waarschijnlijk dat de stam 'vlieg' bij meervoud hoort. Maar de stam gebruik je bij 'ik': ik vlieg. Bij meervoud gebruik je de infinitief: de vogels vliegen. Onthoud: ik = stam, meervoud = infinitief.",
          "3": "Je dacht waarschijnlijk dat alle drie correct zijn. Maar alleen de infinitief (vliegen) is correct bij meervoud. 'Vliegt' hoort bij enkelvoud en 'vlieg' bij 'ik'. Onthoud: bij meervoud is er maar één correcte vorm: de infinitief."
        }
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-006",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "fill_in",
      "question": "Vul de juiste werkwoordsvorm in: 'Wij ___ elke dag naar school.' (fietsen)",
      "correctAnswer": "fietsen",
      "data": {
        "acceptedAnswers": ["fietsen"],
        "placeholder": "werkwoordsvorm"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud = infinitief",
            "content": "Bij wij/jullie/zij (meervoud) gebruik je altijd de infinitief: de hele werkwoordsvorm op -en. Wij fietsen, jullie fietsen, zij fietsen.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_invullen_wij",
      "variantIndex": 6,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Het onderwerp is 'wij' — dat is meervoud. Bij meervoud gebruik je de infinitief: fietsen. Dus: 'Wij fietsen elke dag naar school.'",
        "solutionSteps": [
          "Bepaal het onderwerp: wij → meervoud",
          "Regel: meervoud → infinitief (hele werkwoord op -en)",
          "Infinitief van fietsen = fietsen",
          "Wij fietsen elke dag naar school ✓"
        ]
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-007",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "fill_in",
      "question": "Vul de juiste werkwoordsvorm in: 'De vogels ___ hoog in de lucht.' (vliegen)",
      "correctAnswer": "vliegen",
      "data": {
        "acceptedAnswers": ["vliegen"],
        "placeholder": "werkwoordsvorm"
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud = infinitief",
            "content": "Bij een meervoudig onderwerp (de vogels, de kinderen, wij) gebruik je de infinitief: vliegen, spelen, lopen. Niet de stam + t!",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_invullen_znw",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'De vogels' is meervoud (meer dan één vogel). Bij meervoud gebruik je de infinitief: vliegen. Dus: 'De vogels vliegen hoog in de lucht.'",
        "solutionSteps": [
          "Bepaal het onderwerp: de vogels → meervoud",
          "Regel: meervoud → infinitief (hele werkwoord op -en)",
          "Infinitief van vliegen = vliegen",
          "De vogels vliegen hoog in de lucht ✓"
        ]
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-008",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "error_spotting",
      "question": "Zoek de fout in de werkwoordsvorm en verbeter deze.",
      "data": {
        "text": "De leerlingen maakt samen een werkstuk over dieren.",
        "errors": [
          {
            "word": "maakt",
            "position": 2,
            "correction": "maken",
            "explanation": "'De leerlingen' is meervoud → gebruik de infinitief: maken, niet maakt (stam + t)."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud = infinitief",
            "content": "Bij meervoud (wij, jullie, zij, de leerlingen) gebruik je de infinitief: maken, lopen, spelen. 'Maakt' (stam + t) hoort bij enkelvoud: hij maakt.",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'De leerlingen' is meervoud. Bij meervoud gebruik je de infinitief: maken. 'Maakt' (stam + t) hoort bij enkelvoud (hij maakt). De correcte zin is: 'De leerlingen maken samen een werkstuk over dieren.'",
        "solutionSteps": [
          "Zoek de persoonsvorm: maakt",
          "Bepaal het onderwerp: de leerlingen → meervoud",
          "Meervoud → infinitief: maken (niet maakt)",
          "Correcte zin: De leerlingen maken samen een werkstuk."
        ]
      }
    },
    {
      "id": "SWW-TT-MEERVOUD-009",
      "familyId": "SWW-TT-MEERVOUD",
      "module": "SpellingWW",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_meervoud",
      "questionType": "true_false_series",
      "question": "Zijn deze zinnen correct geschreven?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "De kinderen spelen in de tuin.", "isTrue": true },
          { "text": "Wij fietst elke dag naar school.", "isTrue": false },
          { "text": "De honden rent door het park.", "isTrue": false }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Meervoud = infinitief",
            "content": "Bij meervoud (wij/jullie/zij/de kinderen) gebruik je altijd de infinitief (hele werkwoord op -en).",
            "icon": "book"
          }
        }
      ],
      "conceptId": "tt_meervoud_waar_onwaar",
      "variantIndex": 9,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "'De kinderen spelen' → meervoud + infinitief ✓. 'Wij fietst' → moet 'fietsen' zijn ✗. 'De honden rent' → moet 'rennen' zijn ✗.",
        "solutionSteps": [
          "Meervoud → altijd infinitief (op -en)",
          "'wij fietst' → wij fietsen, 'de honden rent' → de honden rennen"
        ]
      }
    }
  ]
}